import { Component, OnInit } from "@angular/core";
import { CAPService } from "../../core/services/cap-service";
import { Router } from "@angular/router";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  EnterpriseID;
  LoggedInEnterpriseId = "";

  constructor(private CAPService: CAPService, public router: Router) {}

  ngOnInit(): void {}

  ChangeEntId() {
    if (!this.EnterpriseID) {
      alert("Please Enter Enterprise Id");
    } else {
      this.LoggedInEnterpriseId = this.EnterpriseID;
      this.CAPService.LogIn(this.EnterpriseID);
      this.router.navigate(["/Home"]);
    }
  }
}
